var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerRackStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "51px",
    viewBox: "0 0 51 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "store") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 10,
    transform: "translate(-748.000000, -640.000000)",
    fill: "var(--brand-primary)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "store",
    transform: "translate(748.000000, 640.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6875,44.625 L5.3125,44.625 C4.726,44.625 4.25,44.149 4.25,43.5625 C4.25,42.976 4.726,42.5 5.3125,42.5 L45.6875,42.5 C46.274,42.5 46.75,42.976 46.75,43.5625 C46.75,44.149 46.274,44.625 45.6875,44.625 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6875,21.25 L5.3125,21.25 C4.726,21.25 4.25,20.774 4.25,20.1875 C4.25,19.601 4.726,19.125 5.3125,19.125 L45.6875,19.125 C46.274,19.125 46.75,19.601 46.75,20.1875 C46.75,20.774 46.274,21.25 45.6875,21.25 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4375,44.625 L26.5625,44.625 C25.976,44.625 25.5,44.149 25.5,43.5625 L25.5,28.6875 C25.5,28.101 25.976,27.625 26.5625,27.625 L41.4375,27.625 C42.024,27.625 42.5,28.101 42.5,28.6875 L42.5,43.5625 C42.5,44.149 42.024,44.625 41.4375,44.625 Z M27.625,42.5 L40.375,42.5 L40.375,29.75 L27.625,29.75 L27.625,42.5 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,36.125 C33.4135,36.125 32.9375,35.649 32.9375,35.0625 L32.9375,28.6875 C32.9375,28.101 33.4135,27.625 34,27.625 C34.5865,27.625 35.0625,28.101 35.0625,28.6875 L35.0625,35.0625 C35.0625,35.649 34.5865,36.125 34,36.125 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5625,21.25 L11.6875,21.25 C11.101,21.25 10.625,20.774 10.625,20.1875 L10.625,5.3125 C10.625,4.726 11.101,4.25 11.6875,4.25 L26.5625,4.25 C27.149,4.25 27.625,4.726 27.625,5.3125 L27.625,20.1875 C27.625,20.774 27.149,21.25 26.5625,21.25 Z M12.75,19.125 L25.5,19.125 L25.5,6.375 L12.75,6.375 L12.75,19.125 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.125,12.75 C18.5385,12.75 18.0625,12.274 18.0625,11.6875 L18.0625,5.3125 C18.0625,4.726 18.5385,4.25 19.125,4.25 C19.7115,4.25 20.1875,4.726 20.1875,5.3125 L20.1875,11.6875 C20.1875,12.274 19.7115,12.75 19.125,12.75 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3125,44.625 L9.5625,44.625 C8.976,44.625 8.5,44.149 8.5,43.5625 L8.5,30.8125 C8.5,30.226 8.976,29.75 9.5625,29.75 L22.3125,29.75 C22.899,29.75 23.375,30.226 23.375,30.8125 L23.375,43.5625 C23.375,44.149 22.899,44.625 22.3125,44.625 Z M10.625,42.5 L21.25,42.5 L21.25,31.875 L10.625,31.875 L10.625,42.5 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9375,36.125 C15.351,36.125 14.875,35.649 14.875,35.0625 L14.875,30.8125 C14.875,30.226 15.351,29.75 15.9375,29.75 C16.524,29.75 17,30.226 17,30.8125 L17,35.0625 C17,35.649 16.524,36.125 15.9375,36.125 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3125,51 L1.0625,51 C0.476,51 0,50.524 0,49.9375 L0,1.0625 C0,0.476 0.476,0 1.0625,0 L5.3125,0 C5.899,0 6.375,0.476 6.375,1.0625 L6.375,49.9375 C6.375,50.524 5.899,51 5.3125,51 Z M2.125,48.875 L4.25,48.875 L4.25,2.125 L2.125,2.125 L2.125,48.875 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9375,51 L45.6875,51 C45.101,51 44.625,50.524 44.625,49.9375 L44.625,1.0625 C44.625,0.476 45.101,0 45.6875,0 L49.9375,0 C50.524,0 51,0.476 51,1.0625 L51,49.9375 C51,50.524 50.524,51 49.9375,51 Z M46.75,48.875 L48.875,48.875 L48.875,2.125 L46.75,2.125 L46.75,48.875 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerRackStatus);
export default __webpack_public_path__ + "static/media/customer-rack-status.29994e1cc2bd9eca5713ee1d5815e358.svg";
export { ForwardRef as ReactComponent };